<template>
  <section class="layout">
    <div
      class="fixed animate-slide-from-right inset-0 z-30 outline-none items-baseline focus:outline-none justify-end flex"
      v-if="value"
    >
      <div class="relative flex h-screen p-5 w-full max-w-25">
        <div
          class="border-0 overflow-y-auto rounded-xl flex-1 relative w-full bg-white outline-none focus:outline-none"
        >
          <button
            class="ml-auto bg-transparent border-0 text-black opacity-5 flex text-2xl leading-none outline-none focus:outline-none"
            @click.prevent="close"
          >
            <img
              :src="require(`@/assets/svg/X.svg`)"
              alt="Cross"
              class="focus:outline-none pt-4 pr-4"
            />
          </button>
          <div
            class="px-10 border-b border-solid border-blueGray-200 rounded-t-xl"
            v-if="!hideModalHeader"
          >
            <p class="font-semibold text-xl leading-8 tracking-tight">
              Payment information
            </p>

            <section v-show="addNewCard">
              <div class="flex pt-6 pb-5">
                <input
                  type="radio"
                  checked
                  class="w-5 h-5 radio-gray cursor-pointer"
                  @click="onclickToggleNewCard"
                />
                <p
                  class="font-semibold text-base leading-5 ml-3 tracking-tight"
                >
                  Pay with card
                </p>
              </div>
              <p class="font-medium text-sm leading-5 mb-4">Card Details</p>

              <!-- Display a payment form -->
              <form class="mb-4" v-show="clientSecret">
                <div class="mb-4 text-gray-700">
                  <input
                    class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                    type="text"
                    placeholder="Name on card"
                    v-model="$v.nameOnCard.$model"
                    :class="{ 'ring-red-700': $v.nameOnCard.$error }"
                  />
                  <div v-if="$v.nameOnCard.$error">
                    <span
                      class="text-sm font-semibold text-red-600"
                      v-if="!$v.nameOnCard.required"
                    >
                      Your name on card is incomplete.
                    </span>
                  </div>
                </div>
                <!--Stripe.js injects the Payment Element-->
                <div class="mb-4 text-gray-700">
                  <div
                    class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                    id="card-number"
                  ></div>
                </div>
                <div class="mb-4 text-gray-700">
                  <div
                    class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                    id="card-expiry"
                  ></div>
                </div>
                <div class="mb-4 text-gray-700">
                  <div
                    class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                    id="card-cvv"
                  ></div>
                </div>
              </form>

              <!-- <p class="pt-6 font-medium text-sm leading-5">Billing Address</p> -->
              <!-- <input
                type="text"
                placeholder="Postal code"
                class="font-normal text-sm leading-5 text-gray-slate ring-1 mb-6 ring-gray-400 w-full rounded-b-md py-2 px-3 focus:outline-none"
              /> -->
              <div class="flex">
                <input
                  type="checkbox"
                  class="w-5 h-5 mr-2 focus:outline-none"
                  checked
                />
                <p class="font-normal text-sm leading-5">
                  Save this card for future purchases
                </p>
              </div>
            </section>

            <section v-show="!addNewCard">
              <div class="flex pt-6 pb-5">
                <input type="radio" checked class="w-5 h-5 radio-green" />
                <p
                  class="font-semibold text-base leading-5 ml-3 tracking-tight"
                >
                  Pay with card
                </p>
              </div>
              <p class="font-normal text-sm leading-5 text-gray-slate">
                {{
                  userCardList.length == 0 ? "No card added" : "Select card:"
                }}
              </p>
              <div v-for="card in userCardList" :key="card.id">
                <div class="flex my-4" v-if="card.payment_method_id">
                  <input
                    type="radio"
                    class="w-5 h-5 radio-green"
                    @click="onclickPaymentMethodId(card.payment_method_id)"
                  />
                  <p
                    class="font-noraml text-sm leading-5 ml-3 text-gray-slate capitalize"
                  >
                    {{ card.brand || "CARD" }} {{ card.card_number }}
                  </p>
                </div>
              </div>
              <button
                class="font-medium tex-sm leading-5 text-green-light mt-4 focus:outline-none"
                @click="onclickAddnew"
              >
                +Add new card
              </button>
            </section>

            <section class="mt-8">
              <div class="ring-1 ring-gray-50 my-5"></div>
              <p class="pt-6 font-semibold text-xl leading-8 tracking-tight">
                Order Summary
              </p>
              <div class="flex justify-between pt-2">
                <p class="text-sm font-medium leading-4 text-gray-slate">
                  Class Price
                </p>
                <p class="text-sm font-medium leading-4">
                  ${{ intToFloat(details.cost, 2) }}
                </p>
              </div>
              <div class="flex justify-between pt-2">
                <!-- <p class="text-sm font-medium leading-4 text-gray-slate">
                  Service Fee
                </p> -->
                <button
                  class="flex items-center text-gray-slate transition-colors duration-150 bg-white rounded focus:outline-none hover:bg-white"
                  title="This fee helps support the Fitclass platform and covers a broad range of operating costs and customer support."
                >
                  <span class="text-sm">Service Fee</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                    />
                  </svg>
                </button>
                <p class="text-sm font-medium leading-4">
                  ${{ details && intToFloat(details.service_fees, 2) }}
                </p>
              </div>
              <div class="flex justify-between pt-5">
                <p class="text-base font-bold leading-5">Total</p>
                <p class="text-base font-bold leading-6">
                  ${{ intToFloat(details.cost + details.service_fees, 2) }}
                </p>
              </div>
              <button
                class="mt-8 bg-green-light w-full text-white rounded-xl py-2 font-semibold text-base focus:outline-none"
                @click="onclickSubmit"
                v-if="addNewCard"
              >
                {{ isProcessing ? "Processing..." : "Complete Purchase" }}
              </button>
              <button
                class="mt-8 bg-green-light w-full text-white rounded-xl py-2 font-semibold text-base focus:outline-none"
                title="Pay with card"
                @click="onclickPaywithCard"
                v-else
              >
                {{ isProcessing ? "Processing..." : "Complete Purchase" }}
              </button>
              <div class="flex justify-center mt-2">
                <img
                  :src="require(`@/assets/svg/ShieldCheck.svg`)"
                  alt="Shield"
                />
                <p class="font-normal text-sm leading-5 text-gray-slate">
                  Secure Checkout
                </p>
              </div>
              <div class="ring-1 ring-gray-400 my-5"></div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div v-if="value" class="opacity-75 fixed inset-0 z-20 bg-gray-500"></div>
  </section>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CoursePaymentModal",
  props: {
    value: {
      required: true,
    },
    details: {
      type: Object,
    },
    batch: {
      type: Array,
    },
    handleClose: {
      type: Function,
    },
    hideModalHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      addNewCard: false,
      // This is a public sample test API key.
      // Don’t submit any personally identifiable information in requests made with this key.
      // Sign in to see your own test API key embedded in code samples.
      stripe: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID, {
        stripeAccount: this.details && this.details.trainer_account_id,
      }),
      stripe1: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID),

      // The items the customer wants to buy
      elements: {},
      nameOnCard: null,
      paymentMethodId: null,
      clientSecret: null,
      isProcessing: false,
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
    };
  },
  validations: {
    nameOnCard: {
      required,
    },
  },
  watch: {
    async batch(batch) {
      if (this.details && this.details.cost) {
        await this.initialize();
      }
    },
  },
  computed: {
    ...mapGetters(["userCardList", "cardData", "userCompletePaymentBookClass"]),
  },
  methods: {
    ...mapActions([
      "addUserCard",
      "getUserCardList",
      "getCardDetails",
      "postUserCompletePaymentBookClass",
    ]),

    close() {
      if (this.handleClose) {
        this.handleClose(!this.value);
      } else {
        this.$emit("input", !this.value);
      }
      this.addNewCard = false;
    },

    async onclickAddnew() {
      // const appearance = {
      //   theme: "flat",
      //   labels: "floating",
      //   variables: {
      //     fontWeightNormal: "500",
      //     borderRadius: "2px",
      //     colorBackground: "white",
      //     colorPrimary: "#DF1B41",
      //     colorPrimaryText: "white",
      //     spacingGridRow: "15px",
      //   },
      //   rules: {
      //     ".Label": {
      //       marginBottom: "3px",
      //     },
      //     ".Tab, .Input, .Block": {
      //       boxShadow: "0px 3px 10px rgba(18, 42, 66, 0.08)",
      //       padding: "6px",
      //     },
      //   },
      // };

      var style = {
        base: {
          iconColor: "#666EE8",
          color: "#31325F",
          lineHeight: "40px",
          fontWeight: 300,
          fontFamily: "inherit",
          fontSize: "15px",
          "::placeholder": {
            color: "#000",
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        },
      };
      this.elements = await this.stripe1.elements();
      this.cardNumberElement = this.elements.create("cardNumber", {
        style: style,
        placeholder: "Card number",
      });
      this.cardNumberElement.mount("#card-number");

      this.cardExpiryElement = this.elements.create("cardExpiry", {
        style: style,
        placeholder: "MM/YY",
      });
      this.cardExpiryElement.mount("#card-expiry");

      this.cardCvcElement = this.elements.create("cardCvc", {
        style: style,
        placeholder: "CVC",
      });
      this.cardCvcElement.mount("#card-cvv");

      this.addNewCard = !this.addNewCard;
    },

    onclickToggleNewCard() {
      this.addNewCard = !this.addNewCard;
    },

    async initialize() {
      var details = this.getUser("details");
      const payload = {
        entityId: this.$route.params.id,
        entityType: 2, // course
        paymentMethodId: this.paymentMethodId,
        name: details && details.f_name + " " + details && details.l_name,
        line1: details && details.street_address,
        postal_code: details && details.postal_code,
        city: details && details.city,
        state: details && details.state,
        country: details && details.country,
      };
      await axios
        .post(`user/initiate-payment-book-class`, payload)
        .then((res) => {
          const data = res && res.data && res.data.data;
          this.clientSecret = data && data.clientSecret;
          this.paymentMethodId = data && data.paymentMethodId;
        });
    },

    // Fetches a payment intent and captures the client secret
    async onclickSubmit(e) {
      e.preventDefault();
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        this.isProcessing = true;
        let token = null;
        let paymentMethod = null;
        await this.stripe1
          .createToken(this.cardNumberElement)
          .then((result) => {
            if (result.error) {
              console.log(result.error.message);
            } else {
              token = result.token.id;
            }
          });

        if (token == null) {
          this.isProcessing = false;
          return false;
        }

        await axios
          .post(`user/setup-card`, {
            tokenId: token,
            name: this.nameOnCard,
          })
          .then((res) => {
            paymentMethod = res.data.data.paymentMethodId;
          });

        this.paymentMethodId = paymentMethod;

        await this.initialize();

        await this.stripe
          .confirmCardPayment(this.clientSecret, {
            payment_method: this.paymentMethodId,
          })
          .then((result) => {
            if (result.error) {
              alert(result.error.message);
            } else {
              var batchIds =
                this.batch && this.batch.map((e) => e.id).join(", ");
              let data = {
                nameOnCard: this.nameOnCard,
                entityId: this.$route.params.id,
                entityType: 2, // course
                batchId: batchIds,
                paymentIntentid: result.paymentIntent.id,
                paymentMethodId: this.paymentMethodId,
                paymentStatus: "succeeded",
              };
              switch (result.paymentIntent.status) {
                case "succeeded":
                  this.postUserCompletePaymentBookClass(data);
                  this.$emit("book-class", "succeeded");
                  break;
                case "processing":
                  console.log("Processing..");
                  break;
                case "requires_payment_method":
                  alert("Please try again");
                  break;
                default:
                  alert("Something went wrong");
                  break;
              }
            }
          });
      }
    },

    async onclickPaywithCard(e) {
      e.preventDefault();

      if (!this.clientSecret) {
        alert("Please choose payment method");
        return;
      }
      this.isProcessing = true;
      await this.stripe
        .confirmCardPayment(this.clientSecret, {
          payment_method: this.paymentMethodId,
        })
        .then((result) => {
          if (result.error) {
            alert(result.error.message);
          } else {
            var batchIds = this.batch && this.batch.map((e) => e.id).join(", ");
            let data = {
              entityId: this.$route.params.id,
              entityType: 2, // course
              batchId: batchIds,
              paymentIntentid: result.paymentIntent.id,
              paymentMethodId: this.paymentMethodId,
              paymentStatus: "succeeded",
            };
            switch (result.paymentIntent.status) {
              case "succeeded":
                this.postUserCompletePaymentBookClass(data);
                this.$emit("book-class", "succeeded");
                break;
              case "processing":
                console.log("Processing..");
                break;
              case "requires_payment_method":
                alert("Please try again");
                break;
              default:
                alert("Something went wrong");
                break;
            }
          }
        });
      this.isProcessing = false;
    },

    async onclickPaymentMethodId(id) {
      this.paymentMethodId = id;
      await this.initialize();
    },
  },
  async created() {
    await this.getUserCardList();
  },
};
</script>

<style scoped>
.max-w-25 {
  width: 404px;
}

@keyframes slideFromRight {
  0% {
    right: -500px;
  }
  100% {
    right: 0;
  }
}

.animate-slide-from-right {
  animation-name: slideFromRight;
  animation-fill-mode: forwards;
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
}
.radio-gray:checked {
  /* The native appearance is hidden */
  appearance: none;
  -webkit-appearance: none;
  /* For a circular appearance we need a border-radius. */
  border-radius: 50%;
  /* The background will be the radio dot's color. */
  background: darkgray;
  /* The border will be the spacing between the dot and the outer circle */
  border: 3px solid #fff;
  /* And by creating a box-shadow with no offset and no blur, we have an outer circle */
  box-shadow: 0 0 0 1px darkgray;
}
.radio-green:checked {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 50%;
  background: #99c355;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px #99c355;
}
input[type="checkbox"] {
  accent-color: #99c355;
}
</style>